module.exports = __webpack_public_path__ + "0bda8a813aad52aaf03940f60fb3621c.png";